/** Rough editorial pace: characters per minute (plain text after stripping HTML). */
export const READ_CHARS_PER_MINUTE = 1000;

export function plainTextFromHtml(html: string): string {
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function estimateReadMinutesFromHtml(html: string): number {
  const chars = plainTextFromHtml(html).length;
  if (chars === 0) return 1;
  return Math.max(1, Math.ceil(chars / READ_CHARS_PER_MINUTE));
}

/** Keep in-body images off the LCP critical path (hero is the priority image). */
export function withLazyAsyncImages(html: string): string {
  return html.replace(/<img\b([^>]*?)(\s*\/?)>/gi, (_full, attrs: string, closing: string) => {
    let next = attrs;
    if (!/\bloading\s*=/i.test(next)) {
      next += ' loading="lazy"';
    }
    if (!/\bdecoding\s*=/i.test(next)) {
      next += ' decoding="async"';
    }
    return `<img${next}${closing}>`;
  });
}
